import React, { useState, useEffect, Suspense, lazy } from 'react';
import { subscribeToNotifications } from '../utils/notificationService';
import './Notification.css';

// Lazy load the content component to avoid loading icons in the initial bundle
const NotificationContent = lazy(() => import('./NotificationContent'));

const Notification = () => {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const unsubscribe = subscribeToNotifications((newNotification) => {
            const id = Date.now();
            const notificationWithId = { ...newNotification, id };

            setNotifications((prev) => [...prev, notificationWithId]);

            // Auto-remove after 4 seconds
            setTimeout(() => {
                removeNotification(id);
            }, 4000);
        });

        return unsubscribe;
    }, []);

    const removeNotification = (id) => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
    };

    if (notifications.length === 0) return null;

    return (
        <Suspense fallback={null}>
            <NotificationContent notifications={notifications} removeNotification={removeNotification} />
        </Suspense>
    );
};

export default Notification;
